import React from 'react';
import Heading from '../components/heading/Heading';

const Error = () => {
    return (
        <section className="form">
            <div className="container">
                <div className="thanks">
                    <Heading title="You already have a tab with the GRENKE calculator open – please close one of them." />
                </div>
            </div>
        </section>
    )
    
}

export default Error;